import React from 'react';
import {
    getYouTubeEmbedUrl,
    getVimeoEmbedUrl,
    getTikTokEmbedUrl,
    getInstagramEmbedUrl,
    getFacebookEmbedUrl,
    getXEmbedUrl
} from '../utils/mediaUtils';

interface VideoEmbedProps {
    url: string;
    caption?: string | null;
}

export const VideoEmbed: React.FC<VideoEmbedProps> = ({ url, caption }) => {
    const youTubeUrl = getYouTubeEmbedUrl(url);
    const vimeoUrl = getVimeoEmbedUrl(url);
    const tikTokUrl = getTikTokEmbedUrl(url);
    const instagramUrl = getInstagramEmbedUrl(url);
    const facebookUrl = getFacebookEmbedUrl(url);
    const xUrl = getXEmbedUrl(url);

    const embedUrl = youTubeUrl || vimeoUrl || tikTokUrl || instagramUrl || facebookUrl || xUrl;

    // Determine if content is likely vertical (TikTok, Instagram Reels/Stories, FB Reels, YT Shorts)
    const isVertical = !!tikTokUrl || !!instagramUrl || (!!facebookUrl && (url.includes('/reels/') || url.includes('/share/r/'))) || url.includes('/shorts/');

    if (!embedUrl) {
        return (
            <div className="bg-gray-100 rounded-xl p-8 text-center text-gray-500 font-serif italic mb-12">
                Invalid video URL: {url}
            </div>
        );
    }

    return (
        <div className="mb-12 flex justify-center">
            <div className={`relative ${isVertical ? 'aspect-[9/16] max-w-[350px]' :
                xUrl ? 'max-w-[550px] bg-white border border-gray-200 shadow-sm' :
                    'aspect-video bg-black'
                } w-full rounded-xl overflow-hidden shadow-lg`}>
                <iframe
                    src={embedUrl}
                    className={`${(xUrl || facebookUrl) ? 'relative' : 'absolute inset-0'} w-full h-full border-none`}
                    style={{
                        height: xUrl ? '100%' : (facebookUrl && url.includes('/reels/')) ? '600px' : '100%',
                        minHeight: xUrl ? '250px' : 'auto',
                        maxHeight: xUrl ? '450px' : 'none'
                    }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    title="Media Content"
                    loading="lazy"
                />
            </div>
            {caption && (
                <p className="mt-3 text-sm text-gray-500 font-serif italic text-center">
                    {caption}
                </p>
            )}
        </div>
    );
};
